import React, {useState, useEffect, useRef} from 'react';
import './style.scss';
import media from '../../media';


export default function BodyText(props) {
    return(
        <div className="body-text">
            {props.content.heading && <h2 className="heading" dangerouslySetInnerHTML={{__html:props.content.heading}}></h2>}

            {props.content.subheading && <h3 className="subheading" dangerouslySetInnerHTML={{__html:props.content.subheading}}></h3>}

            {props.content.body &&
                <div className="paragraphs">
                    {props.content.body.map((paragraph, key) => {
                        return(
                            <p key={key} dangerouslySetInnerHTML={{__html:paragraph}}></p>
                        );
                    })}
                </div>
            }

            {props.content.instruction && <p className="instruction" dangerouslySetInnerHTML={{__html:props.content.instruction}}></p>}

            {props.content.download && <a className="download" href={media[props.content.download.file]} target="_blank" dangerouslySetInnerHTML={{__html:props.content.download.name}}></a>}
        </div>
    )
}
